"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __importDefault(require("../index"));
var RealisticConductor = (function (_super) {
    __extends(RealisticConductor, _super);
    function RealisticConductor() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.tickAnimation = function () {
            _this.confetti(_this.decorateOptions({
                spread: 26,
                startVelocity: 55,
                origin: { y: 0.7 },
                particleCount: Math.floor(200 * 0.25),
            }));
            _this.confetti(_this.decorateOptions({
                spread: 60,
                origin: { y: 0.7 },
                particleCount: Math.floor(200 * 0.2),
            }));
            _this.confetti(_this.decorateOptions({
                spread: 100,
                decay: 0.91,
                scalar: 0.8,
                origin: { y: 0.7 },
                particleCount: Math.floor(200 * 0.35),
            }));
            _this.confetti(_this.decorateOptions({
                spread: 120,
                startVelocity: 25,
                decay: 0.92,
                scalar: 1.2,
                origin: { y: 0.7 },
                particleCount: Math.floor(200 * 0.1),
            }));
            _this.confetti(_this.decorateOptions({
                spread: 120,
                startVelocity: 45,
                origin: { y: 0.7 },
                particleCount: Math.floor(200 * 0.1),
            }));
        };
        return _this;
    }
    return RealisticConductor;
}(index_1.default));
exports.default = RealisticConductor;
